import NewOrEditProduct from "./NewOrEditProduct";

export default NewOrEditProduct;
